import { Subscription as LiveSubscription, of as liveOf } from 'rxjs';
import { catchError as liveCatchError, timeout as liveTimeout } from 'rxjs/operators';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { CompareResult } from 'src/app/compare-result';
import { UserDetails } from 'src/app/models/userDetails';
import { CompareService } from 'src/app/services/compare-service';
import { SessionService } from 'src/app/services/session-service';
import { TrackingService } from 'src/app/services/tracking-service';
import { CommerceService } from 'src/app/services/commerce-service';
import { UserService } from 'src/app/services/user-service';
import {
  DropdownConfig,
  DropdownOption,
} from '../custom-dropdown/custom-dropdown.component';
import {
  SidebarFilter,
  SidebarFilterConfig,
  SidebarFilterGroup,
} from '../side-bar-filters/side-bar-filters.component';
import { CurrencyPipe } from '@angular/common';
import { RegistrationService } from 'src/app/services/registration-service';
import { PlatePaymentDetails } from 'src/app/models/platePaymentDetails';
import { Registration } from 'src/app/models/registration';

declare global {
  interface Window {
    gtag: any;
    tp: any;
  }
}

export interface CompareFilters {
  sortBy: 'price-ascending' | 'price-descending';
  standardPlates: boolean;
  managedTransfer: boolean;

  offersBespokeFinance: boolean;
  offersKlarna: boolean;

  five_star: boolean;
  four_star: boolean;
  three_star: boolean;
  all_ratings: boolean;
}

@Component({
  selector: 'pla-tp-sellers',
  templateUrl: './tp-sellers.component.html',
  styleUrls: ['./tp-sellers.component.scss'],
})
export class TpSellersComponent implements OnInit {
  public iconClasses = `mid mb-large fw-bold d-block mx-0 mx-md-auto text-center`;

  @Input() public onlyShowLoader: boolean = false;
  @Input() public openFilters: EventEmitter<void> = new EventEmitter<void>();
  @Input() public registration: string;
  @Input() public useCachedResults: boolean = false;
  @Input() public sortChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() public resultsChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() public PriceRangeChange = new EventEmitter<{
    min: number;
    max: number;
    totalResultCount: number;
  }>();
  @Output() public compareFilters = new EventEmitter<
    SidebarFilterConfig<CompareFilters>
  >();
  public compareFilterValues: CompareFilters;
  public mobileFilters: boolean = false;
  public filterConfig: SidebarFilterConfig<CompareFilters> =
    new SidebarFilterConfig<CompareFilters>(
      [
        new SidebarFilterGroup(
          'Sort By',
          [
            new SidebarFilter('sort', 'Sort By', 'sortBy', {
              selectConfig: new DropdownConfig('Sort By', 'swap_vert', [
                new DropdownOption('price-ascending', 'Price Low to High'),
                new DropdownOption('price-descending', 'Price High to Low'),
              ]),
            }),
          ],
          { visible: true, customClass: 'd-block d-lg-none' }
        ),
        new SidebarFilterGroup('Include', [
          new SidebarFilter('checkbox', 'Standard Plates', 'standardPlates', {
            subText:
              'Filter results to include a pair of physical plates that you will need to display your new registration on your vehicle.',
          }),
          new SidebarFilter('checkbox', 'Managed Transfer', 'managedTransfer', {
            subText:
              'Filters results to include dealer managed transfer of your new registration to your vehicle.',
          }),
        ]),
        new SidebarFilterGroup('Finance', [
          new SidebarFilter('checkbox', 'Klarna', 'offersKlarna'),
          new SidebarFilter(
            'checkbox',
            'Bespoke Finance',
            'offersBespokeFinance'
          ),
        ]),
        new SidebarFilterGroup('Rating', [
          new SidebarFilter('checkbox', '5 Star', 'five_star', {
            htmlReplacement: `<div class="d-flex align-items-center justify-content-start gap-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="18.454" height="17.434" viewBox="0 0 18.454 17.434">
                <path id="Path_1319" data-name="Path 1319" d="M7.367,6.367,10.03.672l2.737,5.695,6.5.909-4.277,4.507.586,6.323-5.549-2.7-5.819,2.7.865-6.323L.817,7.275Z" transform="translate(-0.817 -0.672)" fill="#fab506"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="18.454" height="17.434" viewBox="0 0 18.454 17.434">
                <path id="Path_1319" data-name="Path 1319" d="M7.367,6.367,10.03.672l2.737,5.695,6.5.909-4.277,4.507.586,6.323-5.549-2.7-5.819,2.7.865-6.323L.817,7.275Z" transform="translate(-0.817 -0.672)" fill="#fab506"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="18.454" height="17.434" viewBox="0 0 18.454 17.434">
                <path id="Path_1319" data-name="Path 1319" d="M7.367,6.367,10.03.672l2.737,5.695,6.5.909-4.277,4.507.586,6.323-5.549-2.7-5.819,2.7.865-6.323L.817,7.275Z" transform="translate(-0.817 -0.672)" fill="#fab506"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="18.454" height="17.434" viewBox="0 0 18.454 17.434">
                <path id="Path_1319" data-name="Path 1319" d="M7.367,6.367,10.03.672l2.737,5.695,6.5.909-4.277,4.507.586,6.323-5.549-2.7-5.819,2.7.865-6.323L.817,7.275Z" transform="translate(-0.817 -0.672)" fill="#fab506"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="18.454" height="17.434" viewBox="0 0 18.454 17.434">
                <path id="Path_1319" data-name="Path 1319" d="M7.367,6.367,10.03.672l2.737,5.695,6.5.909-4.277,4.507.586,6.323-5.549-2.7-5.819,2.7.865-6.323L.817,7.275Z" transform="translate(-0.817 -0.672)" fill="#fab506"/>
              </svg>
            </div>`,
          }),
          new SidebarFilter('checkbox', '4 Star +', 'four_star', {
            htmlReplacement: `<div class="d-flex align-items-center justify-content-start gap-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="18.454" height="17.434" viewBox="0 0 18.454 17.434">
                <path id="Path_1319" data-name="Path 1319" d="M7.367,6.367,10.03.672l2.737,5.695,6.5.909-4.277,4.507.586,6.323-5.549-2.7-5.819,2.7.865-6.323L.817,7.275Z" transform="translate(-0.817 -0.672)" fill="#fab506"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="18.454" height="17.434" viewBox="0 0 18.454 17.434">
                <path id="Path_1319" data-name="Path 1319" d="M7.367,6.367,10.03.672l2.737,5.695,6.5.909-4.277,4.507.586,6.323-5.549-2.7-5.819,2.7.865-6.323L.817,7.275Z" transform="translate(-0.817 -0.672)" fill="#fab506"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="18.454" height="17.434" viewBox="0 0 18.454 17.434">
                <path id="Path_1319" data-name="Path 1319" d="M7.367,6.367,10.03.672l2.737,5.695,6.5.909-4.277,4.507.586,6.323-5.549-2.7-5.819,2.7.865-6.323L.817,7.275Z" transform="translate(-0.817 -0.672)" fill="#fab506"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="18.454" height="17.434" viewBox="0 0 18.454 17.434">
                <path id="Path_1319" data-name="Path 1319" d="M7.367,6.367,10.03.672l2.737,5.695,6.5.909-4.277,4.507.586,6.323-5.549-2.7-5.819,2.7.865-6.323L.817,7.275Z" transform="translate(-0.817 -0.672)" fill="#fab506"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="18.45" height="17.43" viewBox="0 0 18.45 17.43">
                <path id="Path_1315" data-name="Path 1315" d="M7.366,6.366,10.028.672l2.737,5.694,6.5.908L14.991,11.78l.585,6.322-5.548-2.695L4.21,18.1l.865-6.322L.817,7.274Z" transform="translate(-0.817 -0.672)" fill="#e7e7e7"/>
              </svg>
            </div>`,
          }),
          new SidebarFilter('checkbox', '3 Star +', 'three_star', {
            htmlReplacement: `<div class="d-flex align-items-center justify-content-start gap-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="18.454" height="17.434" viewBox="0 0 18.454 17.434">
                <path id="Path_1319" data-name="Path 1319" d="M7.367,6.367,10.03.672l2.737,5.695,6.5.909-4.277,4.507.586,6.323-5.549-2.7-5.819,2.7.865-6.323L.817,7.275Z" transform="translate(-0.817 -0.672)" fill="#fab506"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="18.454" height="17.434" viewBox="0 0 18.454 17.434">
                <path id="Path_1319" data-name="Path 1319" d="M7.367,6.367,10.03.672l2.737,5.695,6.5.909-4.277,4.507.586,6.323-5.549-2.7-5.819,2.7.865-6.323L.817,7.275Z" transform="translate(-0.817 -0.672)" fill="#fab506"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="18.454" height="17.434" viewBox="0 0 18.454 17.434">
                <path id="Path_1319" data-name="Path 1319" d="M7.367,6.367,10.03.672l2.737,5.695,6.5.909-4.277,4.507.586,6.323-5.549-2.7-5.819,2.7.865-6.323L.817,7.275Z" transform="translate(-0.817 -0.672)" fill="#fab506"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="18.45" height="17.43" viewBox="0 0 18.45 17.43">
                <path id="Path_1315" data-name="Path 1315" d="M7.366,6.366,10.028.672l2.737,5.694,6.5.908L14.991,11.78l.585,6.322-5.548-2.695L4.21,18.1l.865-6.322L.817,7.274Z" transform="translate(-0.817 -0.672)" fill="#e7e7e7"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="18.45" height="17.43" viewBox="0 0 18.45 17.43">
                <path id="Path_1315" data-name="Path 1315" d="M7.366,6.366,10.028.672l2.737,5.694,6.5.908L14.991,11.78l.585,6.322-5.548-2.695L4.21,18.1l.865-6.322L.817,7.274Z" transform="translate(-0.817 -0.672)" fill="#e7e7e7"/>
              </svg>
            </div>`,
          }),
        ]),
      ],
      new EventEmitter<CompareFilters>()
    );

  public viewResults: CompareResult[] = [];

  // Staged loading: stored prices render immediately; dealers that need a paid
  // unblocker and whose stored price is stale (needsLiveCheck from the API) show
  // a per-row loader while their live price is fetched individually. By site.
  public liveState: { [site: string]: 'checking' | 'live' | 'last-seen' } = {};
  private liveLastSeen: { [site: string]: string } = {};
  private liveSubs: LiveSubscription[] = [];
  private liveGeneration = 0;
  public selectedCompareResult: CompareResult;
  public compareResults: CompareResult[] = [];
  public resultsCanShow: boolean = false;

  public withTransfer: boolean = false;
  public withPerspex: boolean = false;
  public transferOnly: boolean = false;
  public financeOnly: boolean = false;
  public seeAll: boolean = false;
  public sort: string = 'price-ascending';
  public loading: boolean = true;
  public searchAlmostComplete: EventEmitter<void> = new EventEmitter<void>();
  public mobileFilterToggle: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  public mobileRowToggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  public toEmit: any = null;
  public notifyForNoResults: boolean = false;
  public notifiying: boolean = false;

  constructor(
    private registrationService: RegistrationService,
    private compareService: CompareService,
    private trackingService: TrackingService,
    private commerceService: CommerceService,
    private sessionService: SessionService,
    private userService: UserService,
    private currencyPipe: CurrencyPipe
  ) {}

  ngOnInit(): void {
    this.SetupFilters();
    this.Compare();

    this.sortChange.subscribe((sort: string) => {
      this.sort = sort;
      this.CreateLists();
    });
    this.openFilters.subscribe(() => {
      this.ToggleMobileFilters(true);
    });
    this.userService.notifiesUpdated.subscribe(() => {
      if (this.registration && this.AvailableResults() <= 0) {
        this.syncNotifyForNoResults();
      }
    });
  }

  public visibleResults(): number {
    /*SHOW ALL + 1 unfaded W/ 9*/
    const availableResults = this.viewResults.filter((r) => r.price > 0).length;
    if (availableResults >= 9) return 9;
    if (availableResults == 0) return 1;
    return availableResults + 1;
  }

  public SetupFilters(): void {
    this.filterConfig.onChange.subscribe((change: CompareFilters) => {
      console.log('new filters', change);
      this.compareFilterValues = change;
      this.sort = change.sortBy;
      this.withTransfer = change.managedTransfer;
      this.transferOnly = change.managedTransfer;
      this.withPerspex = change.standardPlates;
      this.CreateLists();
    });
    this.compareFilters.emit(this.filterConfig);
  }

  public ToggleMobileFilters(visible: boolean): void {
    this.mobileFilterToggle.emit(visible);
  }

  public SelectAllHandler(): void {
    this.seeAll = true;
  }

  public SelectMobileResult(result: CompareResult): void {
    this.selectedCompareResult = result;
    this.mobileRowToggle.emit(true);
  }

  private Compare(): void {
    if (this.registration == '' || this.registration == undefined) return;
    this.CancelLiveChecks();
    this.loading = true;
    this.seeAll = false;
    this.resultsCanShow = false;
    if (this.useCachedResults) {
      this.registrationService
        .getPlatePaymentDetails(this.registration.replace(' ', ''))
        .subscribe((details: PlatePaymentDetails) => {
          console.log('CACHED COMPLETE TRIGGERED');
          this.searchAlmostComplete.emit();
          this.ShowResults(
            details.sellersResp === null ? [] : details.sellersResp.sellers
          );
          this.StartLiveChecks(
            details.sellersResp === null ? [] : details.sellersResp.sellers
          );
        }, () => {
          this.searchAlmostComplete.emit();
          alert("Something went wrong, if this issue persists please contact us.");
          this.ShowResults([]);
        });
    } else {
      this.compareService
        .getPlateComparison(this.registration.replace(' ', ''))
        .subscribe({
          next: (r: CompareResult[]) => {
            console.log('COMPARE COMPLETE TRIGGERED');
            this.searchAlmostComplete.emit();
            this.ShowResults(Array.isArray(r) ? r : []);
          },
          error: () => {
            this.searchAlmostComplete.emit();
            this.ShowResults([]);
          }
        });
    }
  }

  // ---- staged loading ---------------------------------------------------------
  private CancelLiveChecks(): void {
    this.liveGeneration++;
    this.liveSubs.forEach((x) => x.unsubscribe());
    this.liveSubs = [];
    this.liveState = {};
    this.liveLastSeen = {};
  }

  private StartLiveChecks(sellers: any[]): void {
    const pending = (sellers || []).filter((x: any) => x && x.needsLiveCheck && x.site);
    if (!pending.length) return;
    const gen = this.liveGeneration;
    const reg = this.registration.replace(/ /g, '');
    pending.forEach((x: any) => {
      this.liveState[x.site] = 'checking';
      if (x.last_checked) this.liveLastSeen[x.site] = x.last_checked;
    });
    pending.forEach((x: any) => {
      this.liveSubs.push(
        this.registrationService
          .getDealerLivePrice(reg, x.site)
          .pipe(liveTimeout(32000), liveCatchError(() => liveOf(null)))
          .subscribe((res: any) => {
            if (gen !== this.liveGeneration) return; // plate changed meanwhile
            this.ApplyLiveResult(x.site, res);
          })
      );
    });
  }

  private ApplyLiveResult(site: string, res: any): void {
    const fresh = res && (res.status === 'refreshed' || res.status === 'fresh') && res.seller;
    if (!fresh) {
      if (res && res.lastChecked) this.liveLastSeen[site] = res.lastChecked;
      if (res && res.status === 'not_listed') delete this.liveState[site];
      else this.liveState[site] = 'last-seen';
      return;
    }
    // Swap the refreshed seller into the raw data and rebuild, so totals,
    // filters, sorting and the emitted price range all stay consistent.
    const idx = this.compareResults.findIndex((r: any) => r.site === site);
    if (idx > -1) this.compareResults[idx] = res.seller;
    else this.compareResults = [...this.compareResults, res.seller];
    this.liveState[site] = res.seller.price > 0 ? 'live' : undefined;
    if (!this.liveState[site]) delete this.liveState[site];
    this.CreateLists();
    this.CompleteLoad();
  }

  public LiveLastSeenLabel(site: string): string {
    const iso = this.liveLastSeen[site];
    const d = iso ? new Date(iso) : null;
    if (!d || isNaN(d.getTime())) return 'Last seen price';
    return 'Last seen ' + d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  }

  public get LiveCheckingCount(): number {
    return Object.keys(this.liveState).filter((k) => this.liveState[k] === 'checking').length;
  }

  // Show prices the moment they arrive: no artificial wait and no waiting for
  // the loader animation to "finish" (it previously added ~1-5s per page view).
  private ShowResults(results: CompareResult[]): void {
    this.compareResults = results;
    this.SetHistory(results);
    this.CreateLists();
    this.CompleteLoad();
    this.resultsChange.emit(true);
  }

  private SetHistory(results: CompareResult[]): void {
    if (!results || !Array.isArray(results)) return;
    var anyAvailable = results.filter((r) => r.price > 0).length > 0;
    if (!anyAvailable) {
      this.userService.addCompareToHistory(this.registration, 'No Results');
    } else {
      var cheapest = results
        .filter((r) => r.price > 0)
        .sort((r) => r.price)
        .reverse()[0];
      this.userService.addCompareToHistory(
        this.registration,
        this.currencyPipe.transform(cheapest.price, 'GBP')
      );
    }
  }

  public CompleteLoad(): void {
    console.log('TP COMPLETE LOAD');
    this.resultsCanShow = true;
    const payload = this.toEmit != null ? this.toEmit : { min: 0, max: 0, totalResultCount: 0 };
    this.PriceRangeChange.emit(payload);
    this.compareFilters.emit(this.filterConfig);
  }

  public CreateLists(): void {
    if (!this.compareResults || !Array.isArray(this.compareResults)) {
      this.toEmit = { min: 0, max: 0, totalResultCount: 0 };
      this.loading = false;
      setTimeout(() => this.CompleteLoad(), 0);
      return;
    }
    var rawResults = JSON.parse(JSON.stringify(this.compareResults));
    var calculatedRows = this.compareService.calculateFoundRows(
      rawResults,
      this.withTransfer,
      this.withPerspex
    );

    var rawFoundRows = (
      JSON.parse(JSON.stringify(this.compareResults)) as CompareResult[]
    ).filter((r) => r.status == 'FOUND');

    // filter based on options
    if (this.compareFilterValues != undefined) {
      if (this.compareFilterValues.standardPlates) {
        calculatedRows = calculatedRows.filter(
          (cr) => cr.physicalPlatePrice > -1
        );
      }

      if (this.compareFilterValues.managedTransfer) {
        calculatedRows = calculatedRows.filter((cr) => cr.transferService > -1);
      }

      if (this.compareFilterValues.offersKlarna) {
        calculatedRows = calculatedRows.filter(
          (cr) =>
            cr.financeMethods != null &&
            cr.financeMethods.indexOf('klarna') > -1
        );
      }

      if (this.compareFilterValues.offersBespokeFinance) {
        calculatedRows = calculatedRows.filter((cr) => {
          if (cr.finance) return true;
          if (
            cr.financeMethods != null &&
            cr.financeMethods.indexOf('klarna') == -1
          )
            return true;
          return false;
        });
      }

      if (this.compareFilterValues.five_star)
        calculatedRows = calculatedRows.filter((cr) => {
          var trustPilotRating = Math.round(cr.trustPilotScore * 2) / 2;
          return trustPilotRating == 5;
        });

      if (this.compareFilterValues.four_star)
        calculatedRows = calculatedRows.filter((cr) => {
          var trustPilotRating = Math.round(cr.trustPilotScore * 2) / 2;
          return trustPilotRating >= 4;
        });

      if (this.compareFilterValues.three_star)
        calculatedRows = calculatedRows.filter((cr) => {
          var trustPilotRating = Math.round(cr.trustPilotScore * 2) / 2;
          return trustPilotRating >= 3;
        });
    }

    var foundCalculatedRows = [...calculatedRows]
      .filter((r) => r.calculated)
      .sort((a, b) => {
        if (this.sort === 'price-ascending') {
          return a.total - b.total;
        } else if (this.sort === 'price-descending') {
          return b.total - a.total;
        } else {
          return a.total - b.total;
        }
      });

    var notFoundResults = [...calculatedRows].filter(
      (r) => !r.calculated && r.status == 'NOT FOUND'
    );

    this.viewResults = foundCalculatedRows;
    this.viewResults.push(...notFoundResults);

    this.viewResults = this.viewResults.filter((vr) => {
      if (this.transferOnly) {
        if (vr.transferService < 0) return false;
      }

      if (this.financeOnly) {
        if (!vr.finance) return false;
      }

      return true;
    });

    const ___ = [...this.viewResults]
      .filter((r) => r.calculated && r.status !== 'NOT FOUND')
      .sort((a, b) => a.total - b.total);

    try {
      if (___.length > 0) {
        this.toEmit = {
          min: ___[0].total,
          max: ___[___.length - 1].total,
          totalResultCount: rawFoundRows.length,
        };
      } else {
        this.toEmit = {
          min: 0,
          max: 0,
          totalResultCount: rawFoundRows.length,
        }
      }
      this.compareFilters.emit(this.filterConfig);
    } catch {
      console.log('price range fail');
    }

    this.loading = false;
    if (this.AvailableResults() <= 0 && this.registration) {
      this.syncNotifyForNoResults();
    }
  }

  public AvailableResults(): number {
    if (this.viewResults == null) return 0;
    return this.viewResults.filter((r) => r.price > 0).length;
  }

  public trustPilotScoreImage(result: CompareResult): string {
    if (result === undefined) return 'https://www.platex.co.uk/assets/logo.png';
    var trustPilotRating = Math.round(result.trustPilotScore * 2) / 2;
    return `https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-${trustPilotRating}.svg`;
  }

  public openTPLink(result: CompareResult): void {
    window.open(result.trustPilotLink, '_blank');
  }

  public notifyRegistrationForNoResults(): void {
    if (this.notifiying) return;
    this.notifiying = true;
    this.notifyForNoResults = !this.notifyForNoResults;
    this.userService.notifyRegistrationString(
      this.registration,
      (notifs: Registration[]) => {
        const _filteredNotifies = notifs.filter(
          (f) =>
            f.registration.replace(' ', '') === this.registration.replace(' ', '')
        );
        this.notifyForNoResults = _filteredNotifies && _filteredNotifies.length > 0;
        this.notifiying = false;
      }
    );
  }

  private syncNotifyForNoResults(): void {
    this.userService.getUserNotifies((notifs: Registration[]) => {
      if (!notifs || !this.registration) return;
      const filtered = notifs.filter(
        (f) => f.registration.replace(' ', '') === this.registration.replace(' ', '')
      );
      this.notifyForNoResults = filtered.length > 0;
    });
  }

  public openCompareSiteHandler(result: CompareResult): void {
    window.gtag('event', 'page_view', {
      page_title: `Affiliate - ${this.registration.replace(' ', '')} (${
        result.viewName
      })`,
    });

    this.trackingService.TrackAffiliateDetail(
      this.registration,
      result.viewName,
      {
        dealer: result,
      }
    );

    // Authoritative, attributed click capture (commerce / Doc 51): keyed on
    // plate_id + source_id, not registration text. Supersedes the legacy
    // RegistrationTracking affiliate path for billing.
    if (result.sourceId) {
      this.commerceService
        .recordClick({
          registration: this.registration,
          sourceId: result.sourceId,
          clickKind: 'OUTBOUND',
          destinationUrl: result.url,
        })
        .subscribe(
          () => {},
          () => {}
        );
    }

    if (this.sessionService.isLoggedIn()) {
      this.userService.getUserDetails((userDetails: UserDetails) => {
        const trustpilot_invitation = {
          recipientEmail: userDetails.email,
          recipientName: userDetails.firstName,
          referenceId: `PLA_${this.registration.replace(' ', '')}`,
          source: 'InvitationScript',
        };
        // window.tp('createInvitation', trustpilot_invitation);
      });
    }

    if (result.url.indexOf('?') == -1) {
      window.open(
        `${result.url}?token=${this.sessionService.getToken()}`,
        '_blank'
      );
    } else {
      window.open(
        `${result.url}&token=${this.sessionService.getToken()}`,
        '_blank'
      );
    }
  }
}
